import React from "react";
import { Col } from "antd";
import { useSelector } from "react-redux";
import "./surveyInfo.css"; // Import CSS file for styling from root

const SurveyInfo = () => {
  const surveyStats = useSelector((state) => state.landingPage.surveyStats);

  return (
    <Col span={6} className="survey-info">
      <div>
        <h1 className="survey-title">Be heard and impact change!</h1>
        {surveyStats && <h2 className="survey-subtitle">{Number(surveyStats.contributors).toLocaleString()} - Total survey contributors</h2>}
        <p className="survey-text">
          This isn't just another survey - everything you tell us will be used to improve
          your experience with Philips IT. Join us in this journey of making Philips IT better.
        </p>
      </div>
    </Col>
  );
};

export default SurveyInfo;
//Dummy change 01